import * as React from 'react';
import classes from './Help.module.scss';
import { Icon } from '../../../components/images/Icon/Icon';
import { IconsEnum } from '../../../constants/icons';
import { useContext } from 'react';
import { BeaconContext } from '../../../providers/BeaconProvider';
import { useNavigate } from 'react-router-dom';

export const HelpView = (): JSX.Element => {
  const { beacon } = useContext(BeaconContext);
  const navigate = useNavigate();

  const helpCenterOnClick = () => {
    window.open('https://get-help.smarterqueue.com', '_blank');
  };
  const instantAnswersOnClick = () => {
    beacon('open');
    beacon('navigate', '/answers/');
  };

  const whatsNewOnClick = () => {
    navigate({ pathname: '/whats-new' });
  };
  const contactUsOnClick = () => {
    beacon('open');
    beacon('navigate', '/ask/');
  };

  const termsOfServiceOnClick = () => {
    navigate({ pathname: '/terms' });
  };

  const privacyPolicyOnClick = () => {
    navigate({ pathname: '/privacy' });
  };

  return (
    <div className={`${classes.Help}`}>
      {/*<div className={classes.GettingStarted}>*/}
      {/*  <div className={classes.GettingStartedHeader}>*/}
      {/*    <span className={classes.GettingStartedTitle}>Get Started</span>*/}
      {/*    <span className={classes.GettingStartedProgressBarContainer}>*/}
      {/*      <div className={classes.GettingStartedProgressBar}>*/}
      {/*        <span className={classes.GettingStartedProgressBarFill} />*/}
      {/*      </div>*/}
      {/*    </span>*/}
      {/*  </div>*/}
      {/*  <ul className={classes.GettingStartedStepList}>*/}
      {/*    <li className={`${classes.GettingStartedStep} ${classes.StepCompleted}`}>*/}
      {/*      <span>*/}
      {/*        <span className={classes.GettingStartedStepNumber}>1</span>*/}
      {/*      </span>*/}
      {/*      <span className={classes.GettingStartedStepContent}>*/}
      {/*        <span className={classes.StepTitle}>Add Profiles</span>*/}
      {/*        <span className={classes.StepDescription}>Connect the Profiles you&apos;d like to manage</span>*/}
      {/*      </span>*/}
      {/*    </li>*/}
      {/*    <li className={`${classes.GettingStartedStep}`}>*/}
      {/*      <span className={classes.GettingStartedStepNumber}>2</span>*/}
      {/*      <span className={classes.GettingStartedStepContent}>*/}
      {/*        <span className={classes.StepTitle}>Categorize your Content</span>*/}
      {/*        <span className={classes.StepDescription}>Ensure you schedule your content by setting up Categories</span>*/}
      {/*      </span>*/}
      {/*    </li>*/}
      {/*    <li className={`${classes.GettingStartedStep}`}>*/}
      {/*      <span className={classes.GettingStartedStepNumber}>3</span>*/}
      {/*      <span className={classes.GettingStartedStepContent}>*/}
      {/*        <span className={classes.StepTitle}>Create a Posting Plan</span>*/}
      {/*        <span className={classes.StepDescription}>Automate posting at the best times during the week</span>*/}
      {/*      </span>*/}
      {/*    </li>*/}
      {/*    <li className={`${classes.GettingStartedStep}`}>*/}
      {/*      <span className={classes.GettingStartedStepNumber}>4</span>*/}
      {/*      <span className={classes.GettingStartedStepContent}>*/}
      {/*        <span className={classes.StepTitle}>Create & Schedule a Post</span>*/}
      {/*        <span className={classes.StepDescription}>Create your first post in just a few clicks!</span>*/}
      {/*      </span>*/}
      {/*    </li>*/}
      {/*  </ul>*/}
      {/*</div>*/}
      <div>
        <ul className={`${classes.HelpGroup}`}>
          {/*<li className={`${classes.HelpGroupTitle}`}>Help</li>*/}
          <li className={classes.HelpItem} onClick={helpCenterOnClick}>
            <span className={classes.HelpItemContainer}>
              <span className={`${classes.HelpItemIcon} `}>
                <Icon name={IconsEnum.settings} size={'medium'} />
              </span>
              <span className={`${classes.HelpItemTitle}`}>Help Centre</span>
            </span>
          </li>
          {/*<li className={`${classes.HelpItem}`}>*/}
          {/*  <span className={classes.HelpItemContainer}>*/}
          {/*    <span className={`${classes.HelpItemIcon} `}>*/}
          {/*      <Icon name={IconsEnum.team} />*/}
          {/*    </span>*/}
          {/*    <span className={`${classes.HelpItemTitle}`}>Ways To Use SQ</span>*/}
          {/*  </span>*/}
          {/*</li>*/}
          {/*<li className={`${classes.HelpItem}`}>*/}
          {/*  <span className={classes.HelpItemContainer}>*/}
          {/*    <span className={`${classes.HelpItemIcon} `}>*/}
          {/*      <Icon name={IconsEnum.subscription} />*/}
          {/*    </span>*/}
          {/*    <span className={`${classes.HelpItemTitle}`}>Feature Requests</span>*/}
          {/*  </span>*/}
          {/*</li>*/}
          <li className={classes.HelpItem} onClick={instantAnswersOnClick}>
            <span className={classes.HelpItemContainer}>
              <span className={`${classes.HelpItemIcon} `}>
                <Icon name={IconsEnum.team} size={'medium'} />
              </span>
              <span className={`${classes.HelpItemTitle}`}>Instant Answers</span>
            </span>
          </li>
          <li className={classes.HelpItem} onClick={whatsNewOnClick}>
            <span className={classes.HelpItemContainer}>
              <span className={`${classes.HelpItemIcon} `}>
                <Icon name={IconsEnum.whatsNew} size={'medium'} />
              </span>
              <span className={`${classes.HelpItemTitle}`}>What&apos;s New</span>
            </span>
          </li>
          <li className={classes.HelpItem} onClick={contactUsOnClick}>
            <span className={classes.HelpItemContainer}>
              <span className={`${classes.HelpItemIcon} `}>
                <Icon name={IconsEnum.mail} size={'medium'} />
              </span>
              <span className={`${classes.HelpItemTitle}`}>Contact Us</span>
            </span>
          </li>
        </ul>
        <div className={classes.TosPrivacyLinks}>
          <div className={`margin-bottom-small-16`}>
            <a onClick={termsOfServiceOnClick}>Terms of Service</a>
          </div>
          <div>
            <a onClick={privacyPolicyOnClick}>Privacy Policy</a>
          </div>
        </div>
      </div>
    </div>
  );
};
